export default __webpack_public_path__ + "static/media/41.a493f792.jpg";